import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-deeplink",
  templateUrl: "./deeplink.component.html",
  styleUrls: ["./deeplink.component.css"],
})
export class DeeplinkComponent implements OnInit {
  constructor() {}
  androidLink =
    "https://play.google.com/store/apps/details?id=com.daarlo.android";
  iosLink = "https://apps.apple.com/in/app/daarlo/id6497714328";
  webLink = "https://daarloindia.com/";

  ngOnInit() {
    this.goToDeep();
  }

  goToDeep() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes("android")) {
      // It's an Android device
      window.open(this.androidLink, "_self");
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      // It's an iOS device
      window.open(this.iosLink, "_self");
    } else {
      // It's neither Android nor iOS, assuming it's a web browser
      window.open(this.webLink, "_self");
    }
  }
}
